<template>
  <div>
    <v-card flat class="pa-0">
      <v-card-text class="pa-1">
        <v-row class="mx-0">
          <v-spacer/>
          <v-col cols="12" xs="12" sm="6" md="5" lg="4">
            <v-card class="pa-1 text-center headline" outlined tile>
              {{ currentDay }} {{ currentDate }}
            </v-card>
          </v-col>
          <v-spacer/>
        </v-row>
        <v-row class="mx-0 mb-5 mt-3 text-center">
            <v-col cols="12" align="center" class="pa-0">
              <template v-if="!timerData.isTimeRunning">
                <v-badge bordered color="success" icon="mdi-play" overlap class="mr-5">
                  <v-btn :disabled="!timerObj.shift_id ? true : (disableButton ? true : false)" :color="isDisabledTimer || isWeekLocked ? '' : 'success'" :class="isDisabledTimer || isWeekLocked ? 'include_stamp_attachment' : ''" tile @click="start()" class="mr-2">{{$t('message.timer.start')}}</v-btn>
                </v-badge>
              </template>
              <template v-else>
                <v-badge bordered :color="holdTime ? 'orange' : 'success'" icon="mdi-stop" overlap class="mx-2 mr-5">
                  <v-btn tile :color="holdTime ? 'orange' : 'success'" dark @click="stopTimer" class="mr-2" :disabled="buttonDissable"><span>{{ time }}</span></v-btn>
                </v-badge>
              </template>
              <template>
                <input ref="uploader" class="d-none" type="file" accept="image/*" @change="onFileChanged">
              </template>
              <template v-if="timerData.isTimeRunning && timerObj.task_id && canSwitchProject">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="mx-1"
                      v-on="on"
                      fab
                      dark
                      small
                      color="primary"
                      @click="openSwitchProjectDialog"
                    >
                      <v-icon dark>mdi-swap-horizontal</v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t('message.timer.switchProject')}}</span>
                </v-tooltip>
              </template>
              <template v-if="timerData.isTimeRunning">
                <v-tooltip bottom>
                  <template template v-slot:activator="{ on }">
                    <v-btn class="mx-1" v-on="on" fab dark small color="error" @click="showCancelDialog = true">
                      <v-icon dark>mdi-cancel</v-icon>
                    </v-btn>
                   </template>
                  <span>{{$t('message.timer.cancelTimer')}}</span>
                </v-tooltip>
              </template>
              <template v-for="(item, index) in quickNavItems">
                <v-tooltip bottom :key="`${index}_navItem`">
                  <template template v-slot:activator="{ on }">
                    <v-btn class="mx-1" v-on="on" fab dark small color="primary" @click="$router.push(item.to)">
                      <v-icon dark>{{item.icon}}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t(item.tooltipText) }}</span>
                </v-tooltip>
              </template>
              <template>
                <v-tooltip bottom :key="`shift_help_navItem`">
                  <template template v-slot:activator="{ on }">
                    <v-btn class="mx-1" v-on="on" fab dark small color="primary" >
                      <v-icon dark>mdi-information</v-icon>
                    </v-btn>
                  </template>
                    <span v-if="this.$i18n.locale == 'en'">How Stemp works?
                        <ul> <li>Both stemp and Manual hour entry will work based on the shift, where shift is mandatory.</li>
                        <li>Shift is userdefined in Manage hours</li>
                        <li>If an shift is between 9:00 to 18:00, totally 9 hrs, if user starts at 9 it continue untill 18:00, at 18:00, the user will get an alert to stop or continue, if user wishes he can continue.</li>
                        <li>since shift is 9hrs, where he can start stemp at any time. For example, if user starts at 11:00  instead of 9:00, the stemp will alert user at 20:00(calculating 9 hrs)</li>
                        <li>The stemp can be stopped in between too as per the user desired.</li>
                        <li>If user fails to stempout at shift, it automatically stops at 24hrs and there will be alert to the user on their next login.</li>
                        <li>The 24hrs will include (project hours + stemphours +Pausetime + Absence hours) per day.</li>
                        <li>If an stemp includes attachments, it will not logout automatically at 24hrs, instead an alert will arose to include attachment on their next login.</li></ul>
                  </span>
                  <span v-else>
                      Hvordan virker Stemp?
                    <ul>
                      <li>Både stemp og Manuell timeregistrering vil fungere basert på skiftet, hvor skift er obligatorisk.</li>
                      <li>Skift er brukerdefinert i Administrer timer</li>
                      <li>Hvis et skift er mellom 9:00 og 18:00, totalt 9 timer, hvis brukeren starter kl. 9, fortsetter det til kl. 18:00, kl. han kan fortsette.</li>
                      <li>siden skiftet er 9 timer, hvor han kan starte stemp når som helst. for eksempel, hvis brukeren starter kl. 11.00 i stedet for kl. 9.00, vil stemplet varsle brukeren kl. 20.00 (beregner 9 timer)</li>
                      <li>Stemplet kan stoppes i mellom også etter brukerens bekvemmelighet.</li>
                      <li>Hvis brukeren ikke klarer å stoppe ved skiftet, stopper den automatisk ved 24 timer, og brukeren blir varslet ved neste pålogging.</li>
                      <li>De 24 timer vil inkludere (prosjekt timer + stemphours + pausetid + fravær timer) per dag.</li>
                      <li>Hvis en stemp inkluderer vedlegg, vil den ikke logge ut automatisk etter 24 timer, i stedet vil det oppstå et varsel om å inkludere vedlegg ved neste pålogging</li>
                    </ul>
                  </span>
                </v-tooltip>
              </template>
            </v-col>
        </v-row>
        <v-row>
          <v-spacer/>
          <v-col cols="12" xs="12" sm="6" md="5" lg="4" class="px-0 py-1">
            <v-form ref="shiftForm">
              <v-autocomplete @change="shiftChange()" :label="$t('message.timer.shift')" v-model="timerObj.shift_id" clearable :items="shifts" :rules="shiftRules" item-text="displayName" item-value="id" dense hide-details outlined/>
            </v-form>
             <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-information
                  </v-icon>
                </template>
                <span><p class="caption mx-2 my-0"> {{ $t('message.common.stempHint') }}</p></span>
              </v-tooltip>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <v-row class="mx-0">
          <v-spacer></v-spacer>
          <v-col cols="12" xs="12" sm="6" md="5" lg="4" class="pa-0">
            <!-- Same non-blocking warning as the hour form: the punch clock
                 books against an activity too, so an unlinked one fails at sync
                 just as quietly. -->
            <v-alert v-if="billingLinkWarning" type="warning" dense text class="mb-2">
              {{ billingLinkWarning }}
            </v-alert>
            <form-data :references.sync="formReferences" :model="timerObj" ref="hourReference"></form-data>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <v-row class="mx-0 mt-2">
          <v-flex class="xs4 xm3 lg2 pa-1" v-for="image in allAttachments" :key="image.id">
            <v-img
              width="100"
              height="50"
              :src="image.blobUrl"
              @click="selectedImage = image.blobUrl; showImageInFullScreen = true"
            />
          </v-flex>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="showImageInFullScreen">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn fab elevation="0" class="white">
            <v-icon large @click="showImageInFullScreen = false">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-img :src="selectedImage"></v-img>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- DELETE WARNING -->
    <v-dialog v-model="showCancelDialog" persistent max-width="400px" class="mt-0">
      <v-card class="pa-0" flat>
        <v-card-title>
          {{ $t('message.common.confirmCancel') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          {{ $t('message.common.areYouSureCancel') }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" id="confirmCancel" :loading="cancelLoading" @click="confirmCancel">{{ $t('message.common.yes') }}</v-btn>
          <v-btn color="primary" id="closeCancel" @click="showCancelDialog=false">{{ $t('message.common.no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- DELETE WARNING  -->
    <!-- Shift end popup -->
    <v-dialog persistent v-model="shiftEndDialog" width="500">
      <v-card>
        <v-card-title>{{ $t('message.common.confirmAddHour') }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4 font-weight-bold text-h6">
          {{ $t('message.common.doYouWantContinue') }}
          <div v-if="shiftExpectedEnd" class="text-body-2 grey--text text--darken-1 mt-2">
            {{ $t('message.shifts.shiftEndsAt') }} {{ shiftExpectedEnd }}
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="success" @click="continueExceeding()">{{ $t('message.shifts.continue') }}</v-btn>
          <v-btn class="error" @click="popupStopTimer()">{{ $t('message.timer.stop') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Exceed Validaion -->
    <v-dialog width="500" v-model="exeedValidaion" persistent>
      <v-card>
        <v-card-title> {{ $t('message.common.reachedHours') }} </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4 text-h6">
         {{ $t('message.common.on') }} {{ exeedDate }} {{ $t('message.common.hoursExeed') }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary" @click="exeedValidaion=false">{{ $t('message.common.ok') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showSwitchProjectDialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          {{ $t('message.timer.switchProject') }}
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text class="pt-4">
          <v-form ref="switchProjectFormRef">
            <v-textarea
              v-model="switchProjectForm.comment"
              :label="$t('message.common.comments')"
              outlined
              dense
              rows="3"
              :rules="switchProjectRules.comment"
            />

            <v-autocomplete
              v-model="switchProjectForm.project_id"
              :items="getCurrentProjects"
              :item-text="setProjectname"
              item-value="id"
              :label="$t('message.timer.switchProject')"
              outlined
              dense
              clearable
              :rules="switchProjectRules.project_id"
              @change="onSwitchProjectChange"
            />

            <v-autocomplete
              v-model="switchProjectForm.task_id"
              :items="switchProjectActivities"
              item-text="name"
              item-value="task_id"
              :label="$t('message.timer.activity')"
              outlined
              dense
              clearable
              :disabled="!switchProjectForm.project_id"
            />
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="switchProjectLoading"
            @click="confirmSwitchProject"
          >
            {{ $t('message.timer.switchProject') }}
          </v-btn>
          <v-btn
            color="error"
            @click="closeSwitchProjectDialog"
          >
            {{ $t('message.common.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 4993 A3: flex prompt after a successful punch-out (flex tenants only) -->
    <flex-choice-dialog v-model="showFlexChoiceDialog" :summary="flexChoiceSummary"></flex-choice-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import { selectableOptions, activityLabel, workTypeLabel } from '@/utils/activeRecords'
import { anyBillingIntegrationEnabled, billingProviderLabel } from '@/utils/billingProvider'
import { mapGetters } from 'vuex'
import TimerMixin from '../../mixins/timer'
import projectMixin from '@/mixins/projectMixin'
import { needsFlexPrompt, summarizePunchOut } from '@/utils/flexPrompt.mjs'
// import { hostAppApi } from '../../plugins/axios_settings'
export default {
  mixins: [TimerMixin, projectMixin],
  props: ['test', 'shiftTime'],
  data () {
    return {
      currentDay: moment().format('dddd'),
      currentDate: moment().format('DD.MM.YYYY'),
      time: '00:00:00',
      webWorkerInstance: null,
      timerObj: {
        project_id: 0
      },
      listOfActivities: [],
      isInitital: true,
      // getCurrentProjects: [],
      showCancelDialog: false,
      cancelLoading: false,
      listOfbreaks: [{ val: 0 }, { val: 15 }, { val: 30 }, { val: 45 }, { val: 60 }],
      quickNavItems: [
        { icon: 'mdi-calendar-clock', to: '/calendar', tooltipText: 'message.timer.ga_til_time', color: 'info' },
        { icon: 'mdi-calendar-text-outline', to: '/myshifts', tooltipText: 'message.shifts.shift', color: 'primary' }
      ],
      isPictureTakenBefore: false,
      allAttachments: [],
      fileUploadType: 0, // 1-on start , 2- on stop,  3- on store
      selectedImage: '',
      showImageInFullScreen: false,
      reloadApp: false,
      holdTime: false,
      stempDate: null,
      shifts: [],
      startTime: null,
      shiftEndDialog: false,
      shiftExpectedEnd: null,
      continueTime: true,
      yesContinueTime: false,
      currentDateTotal: null,
      currentDateTotalRunningHours: null,
      disableButton: false,
      exeedValidaion: false,
      exeedDate: null,
      startDatetotalHours: false,
      afterSaveRecord: {},
      buttonDissable: false,
      shiftRules: [v => !!v || 'Name is required'],
      integrations: JSON.parse(localStorage.getItem('Integrations') || '{}'),
      showSwitchProjectDialog: false,
      switchProjectLoading: false,
      switchProjectForm: {
        comment: '',
        project_id: null,
        task_id: null
      },
      switchProjectActivities: [],
      switchProjectRules: {
        comment: [v => !!v || 'Comment is required'],
        project_id: [v => !!v || 'Project is required']
      },
      // 4993 A3: flex prompt state (summary from the PATCH /hours/punch-in-out body)
      showFlexChoiceDialog: false,
      flexChoiceSummary: null
    }
  },
  components: {
    'form-data': () => import('@/components/FormTemplate'),
    'flex-choice-dialog': () => import('@/components/FlexChoiceDialog')
  },
  computed: {
    /* See NormalHours for the rule; the integration is named from the server's
       payload rather than hardcoded in the string. */
    billingLinkWarning () {
      if (!anyBillingIntegrationEnabled(this.integrations)) return null

      const activity = (this.listOfActivities || []).find(a => a.task_id === this.timerObj.task_id)
      if (!activity || activity.billing_mapped !== false) return null

      const warning = this.$t('message.timer.not_linked_warning', {
        integration: billingProviderLabel(this.integrations)
      })

      return `${warning} (${this.$t('message.timer.activity')})`
    },
    /* Case 5142 R6 — see NormalHours for the rule. */
    activityOptions () {
      return selectableOptions(
        this.listOfActivities, this.timerObj.task_id, 'task_id',
        activityLabel, this.$t('message.timer.inactive_suffix')
      )
    },
    workTypeOptions () {
      const all = this.getWorktypes.filter(x => x.is_billable && x.additional_work === false)
      return selectableOptions(all, this.timerObj.work_type_id, 'id', workTypeLabel, this.$t('message.timer.inactive_suffix'))
    },
    additionalWorkTypeOptions () {
      const all = this.getWorktypes.filter(x => x.is_billable && x.additional_work)
      return selectableOptions(all, this.timerObj.additional_work_type_id, 'id', workTypeLabel, this.$t('message.timer.inactive_suffix'))
    },
    ...mapGetters(['getuserDetails', 'formType', 'getWorktypes', 'timerData', 'generalSettings', 'hasStampAttachments', 'getCurrentProjects', 'getHostRefApi', 'flexHoursEnabled']),
    /* Show the switch project button only after the selected pause duration has elapsed since the timer started.
       Pause of 0 minutes shows it immediately; 15/30 minutes shows it once the running time reaches that point. */
    canSwitchProject () {
      const pauseMinutes = Number(this.timerObj.break) || 0
      if (pauseMinutes <= 0) return true
      const parts = (this.time || '00:00:00').split(':')
      const elapsedMinutes = (Number(parts[0]) || 0) * 60 + (Number(parts[1]) || 0) + (Number(parts[2]) || 0) / 60
      return elapsedMinutes >= pauseMinutes
    },
    formReferences () {
      return {
        cardFlat: false,
        properties: [{
          model: 'project_id',
          type: this.formType.AUTO_COMPLETE,
          rules: this.$_requiredValidation,
          items: this.getCurrentProjects,
          select_text: (item) => this.setProjectname(item),
          select_value: 'id',
          label: this.$t('message.layout.projects'),
          class: 'xs12',
          is_show: this.$store.state.common.isProjectExcluded ? this.setDefaultProject() : true,
          disabled: this.isDisabledTimer || this.isWeekLocked
        },
        {
          model: 'break',
          type: this.formType.SELECT,
          rules: [], // this.$_requiredValidation,
          items: this.listOfbreaks,
          select_text: (item) => item.val + ` ${this.$t('message.timer.minutes')}`,
          select_value: 'val',
          disabled: this.isDisabledTimer || this.isWeekLocked,
          label: this.$t('message.timer.pause'),
          class: 'xs12',
          change: this.saveItem
        },
        {
          model: 'task_id',
          type: this.formType.AUTO_COMPLETE,
          rules: this.$store.state.common.isProjectExcluded ? [] : this.$_requiredValidation,
          items: this.activityOptions,
          is_list: false,
          click: (search) => false,
          term: '',
          change: this.saveItem,
          select_text: 'display_name',
          select_value: 'task_id',
          label: this.$t('message.timer.activity'),
          class: 'xs12',
          disabled: this.isDisabledTimer || this.isWeekLocked
        }, {
          model: 'work_type_id',
          type: this.formType.AUTO_COMPLETE,
          rules: this.generalSettings.isWorkTypeRequired ? this.$_requiredValidation : [],
          items: this.workTypeOptions,
          is_list: false,
          click: (search) => false,
          term: '',
          change: this.saveItem,
          select_text: 'display_name',
          select_value: 'id',
          label: this.$t('message.common.worktype'),
          class: 'xs12',
          disabled: this.isDisabledTimer || this.isWeekLocked,
          // 4993 A4: flex mode hides the field (the engine assigns the work type per
          // line); created() still sets the default id so the punch payload carries it.
          is_show: !this.flexHoursEnabled
        }, {
          model: 'additional_work_type_id',
          type: this.formType.AUTO_COMPLETE,
          rules: [],
          items: this.additionalWorkTypeOptions,
          is_list: false,
          click: (search) => false,
          term: '',
          change: this.saveItem,
          select_text: 'display_name',
          select_value: 'id',
          label: this.$t('message.timer.additionalWorktype'),
          class: 'xs12',
          disabled: this.isDisabledTimer || this.isWeekLocked,
          is_show: this.integrations.tripletex === 1
        }, {
          model: 'additional_hours',
          type: this.formType.TEXT,
          rules: [],
          change: this.saveItem,
          label: this.$t('message.timer.additional_hours'),
          class: 'xs12',
          disabled: this.isDisabledTimer || this.isWeekLocked || !this.timerObj.additional_work_type_id,
          is_show: this.integrations.tripletex === 1
        }, {
          model: 'location',
          type: this.formType.TEXT,
          rules: [],
          change: this.saveItem,
          label: this.$t('message.timer.place'),
          class: 'xs12',
          disabled: this.isDisabledTimer || this.isWeekLocked
        }, {
          model: 'comments',
          type: this.formType.TEXTAREA,
          rules: this.$_requiredValidation,
          change: this.saveItem,
          label: this.$t('message.common.comments'),
          class: 'xs12',
          rows: 3,
          disabled: this.isDisabledTimer || this.isWeekLocked
        }, {
          model: 'files',
          type: this.formType.FILES,
          rules: [],
          accept: 'image/*',
          change: this.storeFileChange,
          label: this.$t('message.deviation.upload_files'),
          class: 'xs12',
          is_show: this.hasStampAttachments,
          disabled: this.isDisabledTimer || this.isWeekLocked
        }],
        buttons: []
      }
    },
    isDisabledTimer () {
      if (this.hasStampAttachments) return (this.getCurrentProjects.length === 0 || !this.isPictureTakenBefore)
      return this.getCurrentProjects.length === 0
    },
    isShowProjectField () {
      if (this.$store.state.common.isProjectExcluded) { /*  && this.isTimerRunnning */
        if (this.getCurrentProjects.length > 0) {
          const obj = this.getCurrentProjects && this.getCurrentProjects.length > 0 ? this.getCurrentProjects.find(x => x.number === 'TM001') : null
          if (obj) {
            if (!this.timerObj.project_id) this.saveProject(obj.id)
          }
        }
      }
      return !this.$store.state.common.isProjectExcluded
    },
    getBaseUrl () {
      let url = process.env.VUE_APP_URL
      url = url.split('/api')[0]
      return url
    },
    isWeekLocked () {
      return this.$store.state.common.isMonthLocked
    }
  },
  async beforeRouteEnter (to, from, next) {
    await next(vm => {
      if (from && from.path === '/login') vm.reloadApp = true
    })
  },
  async created () {
    await this.getCurrentDayHours()
    this.$store.dispatch('getGeneralSettings').then(() => {
      if (this.$store.state.common.isStempExcluded) this.$router.push('/')
    })
    const date = moment().format('DD.MM.YYYY')
    this.checkWeekLock(date)
    this.$store.dispatch('getWorktypes').then(() => {
      const result = this.getWorktypes.find(x => x.is_default && x.is_billable)
      if (result) this.timerObj.work_type_id = result.id
      const aresult = this.getWorktypes.find(x => x.is_default && x.is_billable)
      if (aresult) this.timerObj.additional_work_type_id = aresult.id
      // this.getProjects()
    })
    this.$eventBus.$on('languageChanged', (locale) => {
      locale = this.getMomentLocale(locale)
      this.currentDay = moment().locale(locale).format('dddd')
      this.currentDate = moment().locale(locale).format('DD.MM.YYYY')
    })
  },
  watch: {
    reloadApp (val) {
      if (val) this.$router.go()
    },
    'timerObj.project_id' (val) {
      if (val && val !== 0) {
        /*  save user_id * project_id in localstorage #7601-pin the project for preselect on next login */
        const pinProject = JSON.stringify({ user_id: this.getuserDetails.id, project_id: val })
        window.localStorage.setItem('stempPinnedProject', pinProject)
        /* #7601 ends */
        this.saveProject(val, false)
        this.getActivitiesForProject(val)
      } else this.listOfActivities = []
    },
    'currentDateTotal' (val) {
      if (this.startDatetotalHours) {
        var n = moment(this.timerObj.start_at, moment.ISO_8601).toDate()
        n.setSeconds(+val * 60 * 60)
        this.time = n.toTimeString().slice(0, val)
      }
    },
    // 4993 A5: settings can arrive after the shifts; relabel once the flag is known.
    flexHoursEnabled (on) {
      if (this.shifts && this.shifts.length) this.shifts = this.$formatter.withShiftDisplayName(this.shifts, on)
    },
    'timerObj.shift_id' (val) {
      localStorage.setItem('shiftValue', val)
      if (this.disableButton) this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'message.common.hourExceedNotification' })
    },
    'time' (val) {
      // var runningHours = this.time
      // runningHours = runningHours.split(':')
      // runningHours = Number(runningHours[0]) + (Number(runningHours[1]) + Number(runningHours[2] / 60)) / 60
      // this.currentDateTotalRunningHours = Number(this.currentDateTotal) + runningHours
      // const remainingTime = (24.00 - Number(this.currentDateTotal)).toFixed(2)
      // const runningTime = (this.currentDateTotalRunningHours - Number(this.currentDateTotal)).toFixed(2)
      // if (runningTime > remainingTime) {
      //   var decimalTimeString = remainingTime
      //   var n = new Date(0, 0)
      //   n.setSeconds(+decimalTimeString * 60 * 60)
      //   this.time = n.toTimeString().slice(0, 8)
      //   const timeHour = moment.duration(this.time).hours()
      //   const timeMinute = moment.duration(this.time).minutes()
      //   const timeSecond = moment.duration(this.time).seconds()
      //   setTimeout(() => {
      //     this.stempDate = moment(this.timerObj.start_at, 'DD-MM-YYYYTHH:mm:ss').add(timeHour, 'h').add(timeMinute, 'm').add(timeSecond, 's').format('YYYY-MM-DD HH:mm:ss')
      //   }, 100)
      //   if (this.webWorkerInstance) this.webWorkerInstance.terminate()
      //   this.webWorkerInstance = null
      //   this.updatePhasuedTime()
      //   // this.stempDate = moment(this.time, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
      //   // this.stopTimer()
      // }
      // if (this.currentDateTotalRunningHours > 24) {
      //   if (this.webWorkerInstance) this.webWorkerInstance.terminate()
      //   this.webWorkerInstance = null
      //   this.updatePhasuedTime()
      // }
      // if (!this.startDatetotalHours)
      this.shiftCalculations()
    }
  },
  async mounted () {
    this.getShifts()
    await this.getRunningStemp()
    var runningHours = this.time
    runningHours = runningHours.split(':')
    runningHours = Number(runningHours[0]) + (Number(runningHours[1]) + Number(runningHours[2] / 60)) / 60
    this.currentDateTotalRunningHours = Number(this.currentDateTotal) + runningHours
    this.$root.$on('stopShift', data => {
      if (data.stop) this.stopTimer()
    })
    // this.$root.$on('continueExceed', data => {
    //   if (data) this.startDatetotalHours = false
    // })
    if (this.test) {
      setTimeout(() => {
        this.stempDate = moment(this.startTime).add(this.shiftTime.hour, 'h').add(this.shiftTime.minute, 'm').add(this.shiftTime.second, 's').format('YYYY-MM-DD HH:mm:ss')
        this.stopTimer()
      }, 1000)
    }
    this.$root.$on('startTimeEmit', data => {
      this.startTime = data
    })
    // this.$root.$on('limitOfHours', data => {
    //   if (new Date().valueOf() > data) this.shiftEndDialog = true
    //   this.time = '08:00:00'
    //   // if (data) this.holdTime = true
    //   this.stempDate = moment(data).format('YYYY-MM-DD HH:mm:ss')
    // })
    this.timerObj.user_id = this.getuserDetails.id
    // Fetch Blobs for images
  },

  methods: {
    checkWeekLock (date) {
      this.$store.dispatch('checkMonthLockedStatus', date).then((response) => { // true or false value
        if (response) this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'message.calendar.dayLocked' })// notification show for month locked
      })
    },
    getProjects () {
      const date = moment().format('MM.DD.YYYY')
      this.$api.execute('get', `projects/get_current_projects?date=${date}`).then((response) => {
        if (response && response.data.length > 0) {
          this.getCurrentProjects = this.$formatter.cloneVariable(response.data)
        }
      })
    },
    getActivitiesForProject (projectId) {
      this.$api.execute('get', `projects/${projectId}/activities?include_inactive=1`)
        .then(response => {
          this.listOfActivities = this.$formatter.cloneVariable(response.data)
        })
    },
    start () {
      if (this.isWeekLocked) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'message.calendar.dayLocked' })
        return
      }
      if (this.getCurrentProjects.length === 0) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'message.projects.noActiveProjects' })
        return
      }
      if (this.hasStampAttachments) {
        this.fileUploadType = 1
        this.$refs.uploader.click()
      } else this.startTimer('')
      /* if (this.$refs.hourReference.$refs.validateForm.validate()) {
      } */
    },
    stopTimer () {
      this.continueTime = false
      this.shiftEndDialog = false
      if (this.hasStampAttachments) {
        if (!this.$refs.hourReference?.$refs.validateForm.validate()) {
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'message.common.validationIssue' })
          return
        }
        this.fileUploadType = 2
        this.$refs.uploader.click()
      } else this.stopTimerHandler()
    },
    stopTimerHandler () {
      if (!this.$refs.hourReference) return
      if (this.$refs.hourReference.$refs.validateForm.validate() && this.timerObj.shift_id && this.$refs.shiftForm.validate()) {
        this.buttonDissable = true
        this.stempDate = this.stempDate ? this.stempDate : ((this.timerObj && this.timerObj.paused_at) ? moment(this.timerObj.paused_at, moment.ISO_8601).toISOString() : null)
        const pausedTime = moment.duration(parseFloat(this.timerObj.break), 'minutes').asHours()
        const ShiftTimer = this.time.split(':')
        const timeHours = Number(ShiftTimer[0]) + Number(ShiftTimer[1]) / 60
        if (Number(timeHours.toFixed(2)) >= Number(pausedTime)) {
          this.$api.execute('patch', '/hours/punch-in-out', { endedAt: this.stempDate ? this.stempDate : null })
            .then(response => {
              this.afterSaveRecord = (response.data && typeof response.data === 'object') ? response.data : {}
              localStorage.setItem(`lastShiftUsed_${this.timerObj.user_id}`, this.timerObj.shift_id)
              localStorage.removeItem(`continueTimer_${this.getuserDetails.id}`)
              localStorage.removeItem('shiftValue')
              // const timerId = this.timerObj.id
              this.resetTimer()
              this.$root.$emit('snackbar', {
                snackbar: true,
                color: 'success',
                text: 'message.common.updatedSuccess'
              })
              this.offerFlexChoice(response) // 4993 A3
              // if ((this.integrations.tripletex === 1 || this.integrations.poweroffice === 1) && this.integrations.tripletex_order !== 1) {
              //   const integrationType = this.integrations.tripletex === 1 ? 'tripletex' : 'poweroffice'
              //   hostAppApi.get(`${this.getHostRefApi}timesheet/stemp/${timerId}?is_start=0&is_stop=1&integration_type=${integrationType}`)
              //     .then((response) => {})
              //     .catch()
              //     .finally(() => { })
              // }
            })
            .finally(() => {
              this.buttonDissable = false
            })
        } else {
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'message.shifts.notValidPausedTime' })
          this.buttonDissable = false
        }
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'message.common.validationIssue' })
    },
    // 4993 A3: a flex tenant's PATCH /hours/punch-in-out answers 200 + summary with
    // flex_prompt_required; legacy keeps 204 (no body) and never opens the dialog.
    offerFlexChoice (response) {
      if (!this.flexHoursEnabled || !response) return
      if (!needsFlexPrompt(response.status, response.data)) return
      this.flexChoiceSummary = summarizePunchOut(response.data)
      this.showFlexChoiceDialog = true
    },
    resetTimer () {
      if (this.webWorkerInstance) this.webWorkerInstance.terminate()
      this.webWorkerInstance = null
      this.$store.commit('clearTimerValue')
      this.$eventBus.$emit('stopTimer')
      this.time = '00:00:00'
      if (this.$refs.hourReference && this.$refs.hourReference.$refs && this.$refs.hourReference.$refs.validateForm) this.$refs.hourReference.$refs.validateForm.reset()
      this.timerObj = {}
      this.timerObj.shift_id = this.afterSaveRecord ? this.afterSaveRecord.shift_id : undefined
      window.localStorage.setItem('is_timer_running', false)
      this.allAttachments = []
      this.isPictureTakenBefore = false
    },
    async saveRecord () {
      this.timerObj.user_id = this.getuserDetails.id
      const model = this.$formatter.cloneVariable(this.timerObj) || {}
      model.start_at = model.start_at ? model.start_at : moment().format('YYYY-MM-DDTHH:mm:ss')
      model.break = moment.duration(parseFloat(model.break || 0), 'minutes').asHours()
      const method = model.id ? 'put' : 'post'
      await this.$api.execute(method, '/hours/punch-in-out', model).then(({ data }) => {
        /* api can respond with a null/empty body - guard so we do not deref null */
        const model = this.$formatter.cloneVariable(data) || {}
        if (model.break) {
          var milliseconds = this.$formatter.getMilliseconds(model.break)
          var duration = moment.duration(milliseconds)
          model.break = parseInt(duration.asMinutes())
        } else model.break = 0
        this.timerObj = this.$formatter.cloneVariable(model)
        this.$store.commit('setTimerObj', data)
        if (!this.timerObj.project_id) this.timerObj.project_id = 0
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: 'message.common.addedSucess' })
      })
    },
    saveProject (id, isSetProjectId = true) {
      if (isSetProjectId && id !== undefined && id !== null) this.timerObj.project_id = id
      if (this.timerObj.id) this.saveRecord()
    },
    saveItem () {
      if (this.timerObj.id) this.saveRecord()
    },
    confirmCancel () {
      this.cancelLoading = true
      this.$api.execute('delete', '/hours/punch-in-out')
        .then(() => {
          var lastShift = Number(localStorage.getItem(`lastShiftUsed_${this.getuserDetails.id}`))
          if (!this.afterSaveRecord || typeof this.afterSaveRecord !== 'object') this.afterSaveRecord = {}
          if (lastShift) this.afterSaveRecord.shift_id = lastShift
          else if (this.shifts && this.shifts.length) this.afterSaveRecord.shift_id = this.shifts[0].id
          this.resetTimer()
          this.showCancelDialog = false
        }).finally(() => {
          this.cancelLoading = false
        })
    },
    setDefaultProject () {
      if (this.getCurrentProjects.length > 0) {
        const obj = this.getCurrentProjects && this.getCurrentProjects.length > 0 ? this.getCurrentProjects.find(x => x.number === 'TM001') : null
        if (obj) {
          if (!this.timerObj.project_id) this.saveProject(obj.id)
        }
      }
      return false
    },
    onFileChanged (e) {
      // check for the first / last image
      if (!e.target.files.length > 0) this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'select files' })
      else {
        this.uploadAttachmentsHandler(e.target.files)
      }
    },
    async uploadAttachmentsHandler (files) {
      if (files.length < 1) {
        return
      }
      if (this.fileUploadType === 1) {
        await this.startTimer('')
      }
      const formData = new FormData()
      formData.append('punchId', this.timerObj.id)
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        formData.append(file.name, file)
      }
      this.$api.execute('post', '/hours/punch-in-out/attachment', formData)
        .then(() => {
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: 'message.timer.uploadSuccess' })
          if (this.fileUploadType === 1) {
            this.isPictureTakenBefore = true
          } else if (this.fileUploadType === 2) {
            this.stopTimerHandler()
            this.allAttachments = []
          } else if (this.fileUploadType === 3) {
            this.timerObj.files = []
          }
          this.getAllFiles()
        }).catch(() => {
          if (this.fileUploadType === 1) {
            this.confirmCancel()
          }
        })
    },
    getAllFiles () {
      this.$api
        .execute('get', '/hours/punch-in-out/attachment')
        .then(({ data }) => { this.allAttachments = data })
        .then(() => {
          this.allAttachments.forEach((image) => {
            this.$api.execute('get', image.url, { responseType: 'blob' }).then((res) => {
              image.blobUrl = URL.createObjectURL(res.data)
            })
          })
        })
    },
    storeFileChange () {
      this.fileUploadType = 3
      if (this.timerObj.files) {
        this.uploadAttachmentsHandler(this.timerObj.files)
      }
    },
    getMomentLocale (locale) {
      switch (locale) {
        case 'en': return 'en'
        case 'no': return 'nb'
        case 'po': return 'pl-PL'
        case 'li': return 'lt'
        case 'sv': return 'sv'
        default: return 'no'
      }
    },
    async getShifts () {
      await this.$api.execute('get', 'shifts/active')
        .then(async (response) => {
          this.shifts = this.$formatter.withShiftDisplayName(this.$formatter.cloneVariable(response.data), this.flexHoursEnabled)
          // Server-side scheduled-shift lookup is the most authoritative source
          // (last-used by this user, then tenant default — cross-device aware).
          // Fall back to the existing local heuristics if it returns nothing or
          // points at a shift we don't have in the active list.
          // 4993: the server suggestion is flex-only; legacy keeps the local heuristics.
          let scheduled = null
          if (this.flexHoursEnabled) {
            scheduled = await this.$store.dispatch('loadScheduledShift', {
              userId: this.getuserDetails.id,
              date: moment().format('DD.MM.YYYY')
            })
          }
          const scheduledShift = scheduled ? this.shifts.find(x => x.id === scheduled.shift_id) : null
          if (scheduledShift) {
            this.timerObj.shift_id = scheduledShift.id
            this.timerObj.break = scheduledShift.break
            return
          }
          const lastShiftUsed = localStorage.getItem(`lastShiftUsed_${this.getuserDetails.id}`)
          const lastShift = this.shifts.find(x => x.id === lastShiftUsed)
          const result = this.shifts.find(x => x.default)
          if (lastShiftUsed && lastShift) {
            this.timerObj.shift_id = lastShiftUsed
            this.timerObj.break = lastShift.break
          } else if (result) {
            this.timerObj.shift_id = result.id
            this.timerObj.break = result.break
          } else if (this.shifts.length > 0) {
            this.timerObj.shift_id = this.shifts[0].id
            this.timerObj.break = this.shifts[0].break
          }
        })
    },
    shiftCalculations () {
      if (!this.shifts || !this.shifts.length) return
      const shiftObj = this.shifts.find(x => x.id === this.timerObj.shift_id)
      if (shiftObj && shiftObj.timeTo) {
        // For cross-midnight shifts (dayOffsetTo > 0) we have to add the day
        // offset to timeTo before diff'ing, otherwise '06:00' - '22:00' goes
        // negative and the dialog never fires. Same-day shifts (offset 0 or
        // undefined for legacy backends) behave exactly as before.
        const offsetDays = Number(shiftObj.dayOffsetTo) || 0
        const hours = moment(shiftObj.timeTo, 'HH:mm').add(offsetDays, 'days').diff(moment(shiftObj.timeFrom, 'HH:mm'))
        this.shiftExpectedEnd = shiftObj.timeTo
        // Backstop: comparison strings below use 'HH:mm:ss' which only accepts
        // 0..23 for the hour. For very long shifts (e.g. dayOffsetTo >= 2) we
        // cap at 23:59 so the dialog still fires by the 24h mark.
        const totalShiftMinutes = Math.min(Math.floor(hours / 60000), 23 * 60 + 59)
        const timeHour = moment.duration(this.time).hours()
        const timeMinute = moment.duration(this.time).minutes()
        const timeSecond = moment.duration(this.time).seconds()
        const shiftHour = Math.floor(totalShiftMinutes / 60)
        const shiftMinute = totalShiftMinutes % 60
        const shiftSecond = 0
        // this.shiftTime = { hour: shiftHour, minute: shiftMinute, second: shiftSecond }
        // Only consider opening the dialog while the user hasn't already
        // chosen "Continue" for this session. yesContinueTime acts as the
        // definitive "user already acknowledged" flag — once true, never
        // pop the dialog again (covers race conditions where continueTime
        // is reset, or where the time watcher fires before user details
        // are ready).
        // this.shiftTime = { hour: shiftHour, minute: shiftMinute, second: shiftSecond }
        if (!this.yesContinueTime && this.continueTime && (moment(`${shiftHour}:${shiftMinute}:${shiftSecond}`, 'HH:mm:ss').isSameOrBefore(moment(`${timeHour}:${timeMinute}:${timeSecond}`, 'HH:mm:ss')) || shiftHour < Number(this.time.toString().split(':')[0]))) {
          const continueExceed = localStorage.getItem(`continueTimer_${this.getuserDetails.id}`)
          if (continueExceed) {
            this.shiftEndDialog = false
            this.continueExceeding()
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: 'message.common.shiftContinue' })
          } else {
            this.shiftEndDialog = true
          }
          this.continueTime = false
        }
        if (!this.yesContinueTime && moment(`${shiftHour}:${shiftMinute}:${shiftSecond}`, 'HH:mm:ss').isSameOrBefore(moment(`${timeHour}:${timeMinute}:${timeSecond}`, 'HH:mm:ss'))) {
          this.time = moment(`${shiftHour}:${shiftMinute}:${shiftSecond}`, 'HH:mm:ss').format('HH:mm:ss')
          this.timerObj.paused_at = moment(this.timerObj.start_at, moment.ISO_8601).add(shiftHour, 'h').add(shiftMinute, 'm').add(shiftSecond, 's').format('DD.MM.YYYYTHH.mm.ss')
        }
      }
    },
    continueExceeding () {
      // Use the logged-in user's id for the storage key so the lookup in
      // shiftCalculations() (which reads getuserDetails.id) finds the flag
      // back. Previously this saved under timerObj.user_id and the reader
      // used getuserDetails.id, so the dialog would re-open after reload.
      const userId = (this.getuserDetails && this.getuserDetails.id) || this.timerObj.user_id
      if (userId) {
        localStorage.setItem(`continueTimer_${userId}`, userId)
      }
      this.shiftEndDialog = false
      this.continueTime = false
      this.yesContinueTime = true
      this.timerObj.paused_at = null
    },
    async popupStopTimer () {
      await this.stopTimer()
      this.shiftEndDialog = false
    },
    getCurrentDayHours (date = moment().format('DD.MM.YYYY')) {
      if (date !== moment().format('DD.MM.YYYY')) this.startDatetotalHours = true
      const start = moment(date, 'DD.MM.YYYY').format('MM.DD.YYYY')
      const end = moment(date, 'DD.MM.YYYY').format('MM.DD.YYYY 23:59:59')
      const model = { start: start, end: end, users: [this.getuserDetails.id], showAllProjects: true }
      this.$api.execute('post', 'hours/filter', model).then((response) => {
        var hoursList = response.data
        const dayStart = moment(date, 'DD.MM.YYYY').startOf('day')
        const dayEnd = moment(date, 'DD.MM.YYYY').endOf('day')
        let totalOfWork = 0
        let totalOfAbsense = 0
        for (var i = 0; i < hoursList.length; i++) {
          // A record can span across midnight (e.g. a punch started the previous
          // day). The API returns any record overlapping the day, so only count
          // the portion that falls within the requested day (00:00 - 23:59:59)
          // by prorating its values against the overlap.
          const recStart = moment(hoursList[i].start_date)
          const recEnd = moment(hoursList[i].end_date)
          const recDuration = recEnd.diff(recStart)
          const overlap = moment.min(recEnd, dayEnd).diff(moment.max(recStart, dayStart))
          if (overlap <= 0) continue
          const fraction = recDuration > 0 ? overlap / recDuration : 1
          const breakHours = isNaN(hoursList[i].break) ? 0 : hoursList[i].break * fraction
          if (hoursList[i].type === 'working') {
            totalOfWork += (hoursList[i].amount * fraction) - breakHours
          }
          if (hoursList[i].type === 'non_working') {
            totalOfAbsense += hoursList[i].amount * fraction
          }
          totalOfAbsense += breakHours
        }
        this.currentDateTotal = (totalOfWork + totalOfAbsense).toFixed(2)
        if (this.currentDateTotal >= 24) {
          this.disableButton = true
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'message.common.hourExceedNotification' })
        }
      })
    },
    updatePhasuedTime () {
      this.timerObj.user_id = this.getuserDetails.id
      const model = this.$formatter.cloneVariable(this.timerObj) || {}
      model.start_at = model.start_at ? model.start_at : moment().format('YYYY-MM-DDTHH:mm:ss')
      model.paused_at = model.paused_at ? model.paused_at : moment().format('YYYY-MM-DD HH:mm:ss')
      model.break = moment.duration(parseFloat(model.break || 0), 'minutes').asHours()
      const url = `stamptimes/update/${model.id}`
      const method = model.id ? 'put' : 'post'
      const msg = model.id ? 'message.common.updatedSuccess' : 'message.common.addedSucess'
      this.$api.execute(method, url, model).then(response => {
        this.$store.commit('setTimerObj', response.data)
        this.exeedDate = moment(response.data.start_at, 'DD.MM.YYYY HH.mm.ss').format('DD.MM.YYYY')
        this.getCurrentDayHours(this.exeedDate)
        this.exeedValidaion = true
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: msg })
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'message.common.hourExceedNotification' })
      })
    },
    shiftChange () {
      if (this.shifts.length) {
        const shiftObj = this.shifts.find(x => x.id === this.timerObj.shift_id)
        if (shiftObj && shiftObj.break) this.timerObj.break = shiftObj.break ? shiftObj.break : this.shifts[0].break
        else this.timerObj.break = this.shifts[0].break
      }
      this.saveItem()
    },
    openSwitchProjectDialog () {
      if (!this.timerData.isTimeRunning) return

      this.switchProjectForm.comment = this.timerObj.comments || ''
      this.switchProjectForm.project_id = null
      this.switchProjectForm.task_id = null
      this.switchProjectActivities = []
      this.showSwitchProjectDialog = true
    },

    onSwitchProjectChange (projectId) {
      this.switchProjectForm.task_id = null
      this.switchProjectActivities = []
      if (!projectId) return
      this.$api.execute('get', `projects/${projectId}/activities?include_inactive=1`)
        .then(response => {
          this.switchProjectActivities = this.$formatter.cloneVariable(response.data)
        })
    },

    closeSwitchProjectDialog () {
      this.showSwitchProjectDialog = false
      this.switchProjectLoading = false
      if (this.$refs.switchProjectFormRef) {
        this.$refs.switchProjectFormRef.resetValidation()
      }
    },

    async confirmSwitchProject () {
      if (!this.$refs.switchProjectFormRef.validate()) return

      if (Number(this.switchProjectForm.project_id) === Number(this.timerObj.project_id)) {
        this.$root.$emit('snackbar', {
          snackbar: true,
          color: 'error',
          text: this.$t('message.timer.selectDifferentProject')
        })
        return
      }

      this.switchProjectLoading = true

      try {
        const oldShiftId = this.timerObj.shift_id
        const oldBreak = this.timerObj.break || 0
        const oldWorkTypeId = this.timerObj.work_type_id || null
        const oldAdditionalWorkTypeId = this.timerObj.additional_work_type_id || null
        const oldAdditionalHours = this.timerObj.additional_hours || null
        const oldLocation = this.timerObj.location || ''

        // 1. save comment on current running record
        this.timerObj.comments = this.switchProjectForm.comment
        await this.saveRecord()

        // 2. stop current running record
        const endTime = moment().toISOString()
        const stopResponse = await this.$api.execute('patch', '/hours/punch-in-out', {
          endedAt: endTime
        })

        // 3. stop local running worker/event
        if (this.webWorkerInstance) this.webWorkerInstance.terminate()
        this.webWorkerInstance = null
        this.$eventBus.$emit('stopTimer')

        // 4. create new timer session with new project
        const newModel = {
          user_id: this.getuserDetails.id,
          project_id: this.switchProjectForm.project_id,
          shift_id: oldShiftId,
          break: oldBreak,
          task_id: this.switchProjectForm.task_id || null,
          work_type_id: oldWorkTypeId,
          additional_work_type_id: oldAdditionalWorkTypeId,
          additional_hours: oldAdditionalHours,
          location: oldLocation,
          comments: '',
          start_at: moment().format('YYYY-MM-DDTHH:mm:ss')
        }

        const { data } = await this.$api.execute('post', '/hours/punch-in-out', newModel)

        const switchedProjectId = this.switchProjectForm.project_id

        this.timerObj = this.$formatter.cloneVariable(data)
        this.$store.commit('setTimerObj', data)

        this.time = '00:00:00'
        this.stempDate = null
        this.continueTime = true
        this.yesContinueTime = false
        this.shiftEndDialog = false
        this.showSwitchProjectDialog = false

        this.switchProjectForm.comment = ''
        this.switchProjectForm.project_id = null

        this.getActivitiesForProject(switchedProjectId)

        this.$root.$emit('snackbar', {
          snackbar: true,
          color: 'success',
          text: this.$t('message.timer.projectSwitchedSuccessfully')
        })

        if (this.startTimer) {
          this.startTimer('')
        }

        // 4993 A3: the stopped half of a switch can carry overtime too; ask once
        // the new punch is running so the prompt never blocks the switch itself.
        this.offerFlexChoice(stopResponse)
      } catch (e) {
        this.$root.$emit('snackbar', {
          snackbar: true,
          color: 'error',
          text: this.$t('message.timer.failedToSwitchProject')
        })
      } finally {
        this.switchProjectLoading = false
      }
    }
  },
  beforeDestroy () {
    this.$root.$off('stopShift')
    this.$root.$off('startTimeEmit')
    // this.$root.$off('limitOfHours')
  }
}
</script>
<style lang="css" scoped>
.include_stamp_attachment {
  background-color: rgba(0, 0, 0, 0.12) !important;
  color: rgba(0, 0, 0, 0.26) !important;;
}
</style>
